<script>
import http from '../core/network/http.js'

function getKanban() {
  return http.get('/api/engineering_kanban/')
}
function addKanban(params) {
  return http.put('/api/engineering_kanban/', params)
}
function updateKanban(params){
  return http.post('/api/engineering_kanban/', params)
}

export default {
  getKanban,
  addKanban,
  updateKanban
}
</script>


// WEBPACK FOOTER //
// src/api/engineering.vue